module.exports = __webpack_public_path__ + "static/media/right-arrow.b80e2ff6.svg";